module.exports = __webpack_public_path__ + "img/padel_club_one.38246dfa.png";